(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rarelock-free-shipping-copy"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__rarelockFreeShippingCopyV2) return;
  window.__rarelockFreeShippingCopyV2 = true;

  var SHIPPING_URL = '/pages/shipping-delivery';
  var SELECTOR = '.product__tax, .tax-note';
  var globalObserver = null;

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function shippingLink() {
    return '<a href="' + SHIPPING_URL + '">Free shipping</a> across Australia.';
  }

  function prefixFor(text) {
    if (/^Duties and taxes included\./i.test(text)) return 'Duties and taxes included. ';
    if (/^Taxes included\./i.test(text)) return 'Taxes included. ';
    if (/^Duties included\./i.test(text)) return 'Duties included. ';
    return '';
  }

  function patchElement(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return;

    var text = cleanText(element.textContent);
    var hasNativeShippingCopy = /shipping\s+(?:is\s+)?calculated at checkout\.?/i.test(text);

    if (hasNativeShippingCopy) {
      var prefix = prefixFor(text);
      if (element.classList.contains('product__tax')) {
        element.innerHTML = prefix + shippingLink();
      } else if (element.classList.contains('tax-note')) {
        element.innerHTML = prefix + shippingLink() + ' Final total confirmed at checkout.';
      }
    }

    /* Reveal only after the native wording has been normalized. */
    element.setAttribute('data-rl-shipping-ready', '1');
  }

  function patchTree(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      var parent = root.parentElement;
      if (parent) {
        var notice = parent.closest && parent.closest(SELECTOR);
        if (notice) patchElement(notice);
      }
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(SELECTOR)) {
      patchElement(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(SELECTOR).forEach(patchElement);
    }
  }

  function observeFromFirstPaint() {
    if (globalObserver || !document.documentElement) return;

    globalObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'characterData') {
          patchTree(record.target);
          return;
        }
        record.addedNodes.forEach(patchTree);
      });
    });

    globalObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function start() {
    patchTree(document);
    observeFromFirstPaint();
  }

  /* Start immediately while the document is still being parsed. MutationObserver
     callbacks run before the browser paints subsequently inserted notices. */
  start();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchTree(document);
    }, { once: true });
  }

  document.addEventListener('shopify:section:load', function (event) {
    patchTree(event.target || document);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
